import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xdzMxY3hzMCB7CiAgYmFja2dyb3VuZC1jb2xvcjogI0RCRERFNDsKICBoZWlnaHQ6IDFweDsKfQ';
export var dividerStyle = '_1w31cxs0';